export enum AuditLogTypes {
    // session starting
    DCUI_NEW_CAPTURE_SESSION_LAUNCHED = "DCUI_NEW_CAPTURE_SESSION_LAUNCHED",
    DCUI_NEW_CAPTURE_SESSION_ATTEMPTED_BUT_NO_REQUEST_TOKEN_FOUND = "DCUI_NEW_CAPTURE_SESSION_ATTEMPTED_BUT_NO_REQUEST_TOKEN_FOUND",
    DCUI_NEW_CAPTURE_SESSION_CONFIG_RETRIEVED_SUCCESSFULLY = "DCUI_NEW_CAPTURE_SESSION_CONFIG_RETRIEVED_SUCCESSFULLY",
    DCUI_NEW_CAPTURE_SESSION_CONFIG_RETRIEVAL_FAILED = "DCUI_NEW_CAPTURE_SESSION_CONFIG_RETRIEVAL_FAILED",
    DCUI_NEW_CAPTURE_SESSION_STARTED_SUCCESSFULLY = "DCUI_NEW_CAPTURE_SESSION_STARTED_SUCCESSFULLY",
    DCUI_NEW_CAPTURE_SESSION_START_FAILED = "DCUI_NEW_CAPTURE_SESSION_START_FAILED",
    // session ending
    DCUI_SAVE_ATTEMPTED = "DCUI_SAVE_ATTEMPTED",
    DCUI_ALL_STEPS_COMPLETE = "DCUI_ALL_STEPS_COMPLETE",
    DCUI_SAVE_ERROR = "DCUI_SAVE_ERROR",
    // capture step starting
    DCUI_SELFIE_STEP_START = "DCUI_SELFIE_STEP_START",
    DCUI_DL_FRONT_STEP_START = "DCUI_DL_FRONT_STEP_START",
    DCUI_DL_BACK_STEP_START = "DCUI_DL_BACK_STEP_START",
    DCUI_ID_CARD_FRONT_STEP_START = "DCUI_ID_CARD_FRONT_STEP_START",
    DCUI_ID_CARD_BACK_STEP_START = "DCUI_ID_CARD_BACK_STEP_START",
    DCUI_PASSPORT_STEP_START = "DCUI_PASSPORT_STEP_START",
    // capture mode setting
    DCUI_ACUANT_MOBILE_MANUAL_CAPTURE_SET = "DCUI_ACUANT_MOBILE_MANUAL_CAPTURE_SET",
    DCUI_ACUANT_DESKTOP_MANUAL_CAPTURE_SET = "DCUI_ACUANT_DESKTOP_MANUAL_CAPTURE_SET",
    DCUI_ACUANT_MOBILE_LIVE_CAPTURE_SET = "DCUI_ACUANT_MOBILE_LIVE_CAPTURE_SET",
    // image capture 
    DCUI_CAPTURE_BUTTON_HIT = "DCUI_CAPTURE_BUTTON_HIT",
    DCUI_ACUANT_SELFIE_CAMERA_STARTED = "DCUI_ACUANT_SELFIE_CAMERA_STARTED",
    DCUI_ACUANT_MANUAL_CAMERA_STARTED = "DCUI_ACUANT_MANUAL_CAMERA_STARTED",
    DCUI_ACUANT_LIVE_CAMERA_LAUNCHED = "DCUI_ACUANT_LIVE_CAMERA_LAUNCHED",
    // image capture error
    DCUI_ACUANT_LIVE_CAPTURE_ERROR = "DCUI_ACUANT_LIVE_CAPTURE_ERROR",
    DCUI_ACUANT_MANUAL_CAPTURE_ERROR = "DCUI_ACUANT_MANUAL_CAPTURE_ERROR",
    DCUI_ACUANT_IMAGE_CROPPING_ERROR = "DCUI_ACUANT_IMAGE_CROPPING_ERROR",
    DCUI_ACUANT_SELFIE_LIVENESS_FAILED_REPEATEDLY = "DCUI_ACUANT_SELFIE_LIVENESS_FAILED_REPEATEDLY",
    DCUI_ACUANT_LIVE_CAMERA_SWITCHED_TO_MANUAL = "DCUI_ACUANT_LIVE_CAMERA_SWITCHED_TO_MANUAL",
    DCUI_ACUANT_LIVE_CAMERA_CLOSED_ABNORMALLY = "DCUI_ACUANT_LIVE_CAMERA_CLOSED_ABNORMALLY",
    // image capture success
    DCUI_ACUANT_IMAGE_CAPTURED = "DCUI_ACUANT_IMAGE_CAPTURED",
    DCUI_ACUANT_SELFIE_CAPTURE_COMPLETED = "DCUI_ACUANT_SELFIE_CAPTURE_COMPLETED",
    DCUI_ACUANT_LIVE_CAMERA_CLOSED_NORMALLY = "DCUI_ACUANT_LIVE_CAMERA_CLOSED_NORMALLY",
    DCUI_SAVE_BUTTON_HIT = "DCUI_SAVE_BUTTON_HIT",
    DCUI_DISCARD_BUTTON_HIT = "DCUI_DISCARD_BUTTON_HIT",
    // image previewed
    DCUI_DL_IMAGE_PREVIEWED = "DCUI_DL_IMAGE_PREVIEWED",
    DCUI_SELFIE_IMAGE_PREVIEWED = "DCUI_SELFIE_IMAGE_PREVIEWED",
    DCUI_PASSPORT_IMAGE_PREVIEWED = "DCUI_PASSPORT_IMAGE_PREVIEWED",
    // quality check - liveness
    DCUI_LIVENESS_CHECK_START = "DCUI_LIVENESS_CHECK_START",
    DCUI_NEW_LIVENESS_CHECK_STARTED = "DCUI_NEW_LIVENESS_CHECK_STARTED",
    DCUI_ACUANT_SELFIE_CAPTURE_CHECKING_LIVENESS = "DCUI_ACUANT_SELFIE_CAPTURE_CHECKING_LIVENESS",
    DCUI_ACUANT_LIVENESS_REDIRECT_TRIGGERED = "DCUI_ACUANT_LIVENESS_REDIRECT_TRIGGERED",
    DCUI_ACUANT_LIVENESS_CHECK_PASSED = "DCUI_ACUANT_LIVENESS_CHECK_PASSED",
    DCUI_ACUANT_LIVENESS_CHECK_ERRORED = "DCUI_ACUANT_LIVENESS_CHECK_ERRORED",
    DCUI_ACUANT_LIVENESS_CHECK_COMPLETED_ABNORMALLY = "DCUI_ACUANT_LIVENESS_CHECK_COMPLETED_ABNORMALLY",
    DCUI_LIVENESS_CHECK_SUCCESS = "DCUI_LIVENESS_CHECK_SUCCESS",
    DCUI_LIVENESS_CHECK_FAILURE = "DCUI_LIVENESS_CHECK_FAILURE",
    // quality checks - fail
    DCUI_ACUANT_IMAGE_VALIDATION_GLARE_DETECTED = "DCUI_ACUANT_IMAGE_VALIDATION_GLARE_DETECTED",
    DCUI_ACUANT_IMAGE_VALIDATION_BLUR_DETECTED = "DCUI_ACUANT_IMAGE_VALIDATION_BLUR_DETECTED",
    DCUI_ACUANT_IMAGE_VALIDATION_LOW_DPI_DETECTED = "DCUI_ACUANT_IMAGE_VALIDATION_LOW_DPI_DETECTED",
    DCUI_PORTRAIT_ORIENTATION_FAILED = "DCUI_PORTRAIT_ORIENTATION_FAILED",
    DCUI_LANDSCAPE_ORIENTATION_FAILED = "DCUI_LANDSCAPE_ORIENTATION_FAILED",
    DCUI_FACE_DETECTION_FAILED = "DCUI_FACE_DETECTION_FAILED",
    // quality checks - pass
    DCUI_ACUANT_IMAGE_VALIDATION_NO_LOW_DPI_DETECTED = "DCUI_ACUANT_IMAGE_VALIDATION_NO_LOW_DPI_DETECTED",
    DCUI_ACUANT_IMAGE_VALIDATION_NO_GLARE_DETECTED = "DCUI_ACUANT_IMAGE_VALIDATION_NO_GLARE_DETECTED",
    DCUI_ACUANT_IMAGE_VALIDATION_NO_BLUR_DETECTED = "DCUI_ACUANT_IMAGE_VALIDATION_NO_BLUR_DETECTED",
    DCUI_PORTRAIT_ORIENTATION_PASSED = "DCUI_PORTRAIT_ORIENTATION_PASSED",
    DCUI_LANDSCAPE_ORIENTATION_PASSED = "DCUI_LANDSCAPE_ORIENTATION_PASSED",
    DCUI_FACE_DETECTION_PASSED = "DCUI_FACE_DETECTION_PASSED"
}